import React, { useState, useEffect } from 'react'

function SmartLabelAnswer(props) {
  const { ActivityJson } = props //Common values to mode screen

  const { isImageLoaded } = props //Values to mode screen
  const [coordinateArray, setCoordinateArray] = useState([])

  useEffect(() => {
    const exercise = JSON.parse(ActivityJson)
    let modifiedArray = exercise.SmartLabelBoxes.map((c) => {
      c.Rotation = c.Rotation.toString().concat('deg')
      return c
    })
    setCoordinateArray(modifiedArray)
  }, [])

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {isImageLoaded &&
        coordinateArray.map((box, index) => {
          const {
            ControlID,
            XAxis,
            YAxis,
            FontSize,
            Rotation,
            Weight,
            Width,
            Height,
            CorrectAnswer
          } = box

          return (
            <div
              key={ControlID.toString()}
              style={{
                position: 'absolute',
                top: YAxis,
                left: XAxis,
                transform: `rotate(${Rotation})`,
                transformOrigin: '0px 0px',
                width: Width.concat('%'),
                height: Height.concat('%'),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              className='green-box'
            >
              <p style={{ margin: 'auto' }}>{CorrectAnswer}</p>
            </div>
          )
        })}
    </div>
  )
}

export { SmartLabelAnswer }
